import { ButtonHTMLAttributes, ReactNode } from 'react';
import { tabButton } from './tabButton.css';

type TabButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: ReactNode;
  enabled: boolean;
};

export const TabButton = ({
  type = 'button',
  children,
  enabled,
  ...props
}: TabButtonProps) => {
  return (
    <button
      type={type}
      className={tabButton({
        enabled,
      })}
      {...props}>
      {children}
    </button>
  );
};
